import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export async function renderShapeWidget(context, widget, parent, override = null) {

    const svgPath = widget.content;
    if (!svgPath || isZeroDimensionShape(widget)) return;
    const svgText = await fetchSVG(svgPath);
    if (!svgText) return;

    // <a class="widget shape_widget">
    const anchor = context.document.createElement("a");
    anchor.classList.add("widget", "shape_widget");
    const breakpoint = context.currentBreakpoint;

    // <img class="shapeWrapper">
    const img = context.document.createElement("img");
    img.classList.add("shapeWrapper");

    const styledSvg = applySVGStyles(context, widget, svgText);
    const encoded = btoa(unescape(encodeURIComponent(styledSvg)));

    img.setAttribute("src", `data:image/svg+xml;base64,${encoded}`);

    anchor.appendChild(img);


    const styles = {
            ...getBaseStyles(widget, breakpoint)
    };

    anchor.setAttribute("style", cssUtil.toStyleString(styles));
    anchor.setAttribute("data-widgetId", widget.uid);
    anchor.setAttribute("data-widgetType", widget.type);
    anchor.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(anchor);
    return anchor;
}

async function fetchSVG(path) {
    const url = `${window.location.origin}${path}`;
    try {
        const res = await fetch(url);
        if (!res.ok) return null;
        return await res.text();
    } catch (e) {
        console.error("Unable to read svg", e);
        return null;
    }
}

function applySVGStyles(context, widget, svgText) {
    const props = widget.properties.desktop;
    const strokeWidth = props.stroke?.width || 0;

    const svgStyles = {};

    // FILL
    if (props.fill) {
        if (props.fill.type === "gradient") {
            svgStyles.fill = cssUtil.getCssGradient(props.fill);
        } else if (props.fill.type === "solid") {
            svgStyles.fill = cssUtil.getCssColor(props.fill);
            svgStyles["fill-opacity"] = props.fill.a;
        }
    }

    // STROKE
    if (props.stroke?.color && strokeWidth > 0) {
        if (props.stroke.color.type === "gradient") {
            svgStyles.stroke = cssUtil.getCssGradient(props.stroke.color);
        } else if (props.stroke.color.type === "solid") {
            svgStyles.stroke = cssUtil.getCssColor(props.stroke.color);
            svgStyles["stroke-opacity"] = props.stroke.color.a;
        }
        svgStyles["stroke-width"] = strokeWidth;
    }


    // FLIP
    if (props.flip) {
        let transform = "rotate(0deg)";
        if (props.flip.vertical) transform = "rotateX(180deg)";
        if (props.flip.horizontal) transform += " rotateY(180deg)";
        svgStyles.transform = transform;
    }

    // Parse SVG
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");
    const svg = doc.querySelector("svg");

    svg.setAttribute("style", cssUtil.toStyleString(svgStyles));

    // non-scaling stroke
    svg.querySelectorAll("path, rect, circle, line, polygon")
        .forEach(el => el.setAttribute("vector-effect", "non-scaling-stroke"));

    // Expand viewBox for stroke width
    const viewBox = svg.getAttribute("viewBox");
    if (viewBox && strokeWidth > 0) {
        const [x, y, w, h] = viewBox.split(" ").map(Number);
        if ([x, y, w, h].every(n => !isNaN(n))) {
            const half = strokeWidth / 2;
            svg.setAttribute(
                "viewBox",
                `${x - half} ${y - half} ${w + strokeWidth} ${h + strokeWidth}`
            );
        }
    }

    return svg.outerHTML;
}

function isZeroDimensionShape(widget) {
    const layout = widget?.properties?.desktop?.layout;
    if (!layout) return true;

    const w = cssUtil.parseDouble(layout.width);
    const h = cssUtil.parseDouble(layout.height);

    return w <= 0 || h <= 0;
}